import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import { userRoutes } from '../../routes/allRoutes'

const Breadcrumb = props => {
  const findingLink = (value) =>{
    const obj = userRoutes.find(x=>x.name===value)
    if (obj){
      return obj.path.toString()
    }else{
      return '#'
    }
  }

  const findingName = (value) =>{
    const obj = userRoutes.find(x=>x.name===value)
    if (obj){
      return obj.title.toString()
    }else{
      return '#'
    }
  }

  return (
    <Row className="mb-3">
      <Col className="col-12">
        <div className="page-title-box d-flex align-items-center justify-content-between">
          <div className="page-title-left">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="/home" >
                  <span className="mdi mdi-home-variant h5 me-1"></span>
                </Link>
              </BreadcrumbItem>
              {
                props.breadcrumbItem1 ? 
                <BreadcrumbItem active>
                  <Link to={findingLink(props.breadcrumbItem1)}>{findingName(props.breadcrumbItem1)}</Link>
                </BreadcrumbItem> : null
              }
              {
                props.breadcrumbItem2 ? 
                <BreadcrumbItem active>
                  <Link to={findingLink(props.breadcrumbItem2)}>{findingName(props.breadcrumbItem2)}</Link>
                </BreadcrumbItem> : null
              }
              {
                props.breadcrumbItem3 ? 
                <BreadcrumbItem active>
                  <Link to={findingLink(props.breadcrumbItem3)}>{findingName(props.breadcrumbItem3)}</Link>
                </BreadcrumbItem> : null
              }
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
